import './SpectrumMenu.scss';

// eslint-disable-next-line import/prefer-default-export
export { Menu as SpectrumMenu } from '@adobe/react-spectrum';
